import { systemEngineEnvironment } from "services/environment/systemEngine";

export const stopEngineMutation = async (name: string) => {
  return systemEngineEnvironment.execute(`STOP ENGINE "${name}"`);
};

export const forceStopEngineMutation = async (name: string) => {
  return systemEngineEnvironment.execute(`STOP ENGINE "${name}" WITH TERMINATE = TRUE`);
};
